import React from 'react'
import { FormControl, Select, MenuItem, makeStyles } from '@material-ui/core'


const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  question: {
    fontFamily: 'Montserrat',
    color: '#818284',
    letterSpacing: -0.4,
    marginBottom: 16
  }
}))




export default function Decades(props){
  const classes = useStyles()
  const { decade, decades, change } = props

  const handleChange = (e) => {
    change(e.target.value)
  }



  return (
    <FormControl className={classes.formControl}>
      <div className={classes.question}>In what decade did this happen?</div>
      <Select
        value={decade}
        onChange={handleChange}>
        {decades.map((decade, i) => (
          <MenuItem key={i} id={decade.value} value={decade.value}>{decade.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
